export class USER {
  static TABLE_HEAD = [
    { id: 'row', label: '' },
    { id: 'userId', label: 'userId' },
    { id: 'email', label: 'email' },
    { id: 'nickname', label: 'nickname' },
    { id: 'username', label: 'username' },
    { id: 'title', label: 'title' },
    { id: 'userType', label: 'userType' },
    { id: 'userState', label: 'userState' },
    { id: 'deviceIds', label: 'deviceIds' },
    { id: 'pushIds', label: 'pushIds' },
    { id: 'history', label: 'history' },
    { id: 'moreMenu', label: '' }
  ];

  static USER_TYPE = ['person', 'group', 'bot', 'org'];

  static USER_STATE = ['normal', 'blocked', 'revoked', 'deprecated'];

  static SEARCH_FIELDS = ['userId', 'email', 'username', 'nickname'];
}
